import React from "react";

import { P, SectionHeading, SectionMainWrapper, SectionSubHeading, SectionWrapper, Text } from "../../Styles/style";

import arbscan from "../../../assets/images/arbscan.png"
import metamask from "../../../assets/images/metamask.png"
import uniswap from "../../../assets/images/uniswap.png"
import dextools from "../../../assets/images/dextools.png"
import styled from "@emotion/styled";
import { Container, Grid, useTheme } from "@mui/material";
import arbvideo from "../../../assets/images/mainanim.mp4"

const VideoBK = styled.video`
  object-fit: cover;
  width: 100%;
  max-width: 100%;
  height: auto;
`;
const GridHEading = styled(Grid)`
padding: 50px 0;
display: flex;
align-items: center;
@media screen and (max-width:599px){
  padding: 0px 0;
}
`;
const GridVideo = styled(Grid)`
mix-blend-mode: lighten;
`;
const GridImage = styled(Grid)`
padding: 50px 0;
/* place-content: ${(props) => (props.pc ? props.pc : "center")};
text-align: center; */
text-align: left;

@media screen and (max-width:599px){
  padding: 0px 0;
}
`;
const JOiningLinks = styled.img`
  /* width: 100%;
  max-width: ${(props) => (props.mw ? props.mw : "180PX")}; */
  margin-right: 10px;
  @media screen and (max-width:599px){
   /* max-width: ${(props) => (props.mw ? props.mw : "140PX")}; */

 }
`
const Arbspoan = styled.span`
 color: ${(props) => props.theme.textTertiary};
  font-size: ${(props) => props.fs ? props.fs : "calc(45px + (26 - 22) * ((100vw - 146px) / (1600 - 250)))"};
font-family: "P-R";
  width: ${(props) => (props.maxWidth ? props.maxWidth : "100%")};
  padding: ${(props) => (props.p ? props.p : "10px 0")};
  text-align: ${(props) => (props.align ? props.align : "")};
  font-weight: 200;
  margin: ${(props) => (props.m ? props.m : "")};

  @media screen and (max-width: 972px) {
    font-size: ${(props) => props.fs ? props.fs : "calc(40px + (26 - 20) * ((100vw - 16px) / (1600 - 250)))"};
  }
  @media screen and (max-width: 419px) {
    font-size: ${(props) => props.fs ? props.fs : "calc(40px + (26 - 10) * ((100vw - 26px) / (1600 - 250)))"};
  }
`
const BuyNow = styled.a`
text-decoration: none;
background-color: ${(props) => (props.bgColor ? props.bgColor : props.theme.textTertiary)};
color: ${(props) => (props.Color ? props.Color : props.theme.textPrimary)};
border-radius: 5px;
padding: 8px 50px;
margin-right: 15px;
@media screen and (max-width:499px){
  padding: 8px 25px;

}

`
const Section1_Header = () => {
  const theme = useTheme()
  return (
    <SectionMainWrapper p="0rem 0" id="home">
      <Container maxWidth="xl">

        <GridHEading container >

          <GridImage xs={12} md={6}>
            <SectionHeading
              p="30px 0 20PX"
              m="0"
              data-aos="flip-up"
              data-aos-easing="ease-in"
              data-aos-delay="400"
              data-aos-duration="600"
              data-aos-offset="0"
            >
              Buy, Hold &<br />
              Earn Passive <Arbspoan>Arbitrum</Arbspoan>
            </SectionHeading>
            <P
              maxWidth="70%"
              p="0 0 40px 0"
              m="0"

              data-aos="flip-up"
              data-aos-easing="ease-in"
              data-aos-delay="500"
              data-aos-duration="500"
              data-aos-offset="0"
            >
              Welcome to ArbFlow, a revolutionary cryptocurrency token built on the Arbitrum network that rewards users with Arbitrum coins. Our platform is designed to provide a steady and passive source of income for our holders while fostering a strong and supportive community of investors.
            </P>
            <div data-aos="flip-up"
              data-aos-easing="ease-in"
              data-aos-delay="700"
              data-aos-duration="500"
              data-aos-offset="0"
            >

              <BuyNow
                href="/"
                target="_blank">
                Buy Now
              </BuyNow>
              <BuyNow bgColor={theme.textPrimary}
                Color={theme.textTertiary}
                data-aos="flip-up"
                data-aos-easing="ease-in"
                data-aos-delay="700"
                data-aos-duration="700"
                data-aos-offset="0"
                href="/"
                target="_blank">
                View Chart
              </BuyNow>
            </div>
            <SectionSubHeading p="40px 0 20px"
              data-aos="flip-up"
              data-aos-easing="ease-in"
              data-aos-delay="800"
              data-aos-duration="400"
              data-aos-offset="0">Partners:</SectionSubHeading>
            <a href="#"
              data-aos="zoom-in-up" 
              data-aos-easing="ease-in"
              data-aos-delay="900"
              data-aos-duration="500"
              data-aos-offset="0">
              <JOiningLinks src={arbscan} />
            </a>
            <a href="#"    data-aos="zoom-in-up" 
              data-aos-easing="ease-in"
              data-aos-delay="1000"
              data-aos-duration="500"
              data-aos-offset="0">
              <JOiningLinks src={metamask} />
            </a>
            <a href="#"    data-aos="zoom-in-up" 
              data-aos-easing="ease-in"
              data-aos-delay="1100"
              data-aos-duration="500"
              data-aos-offset="0">
              <JOiningLinks src={uniswap} />
            </a>
            <a href="#"    data-aos="zoom-in-up" 
              data-aos-easing="ease-in"
              data-aos-delay="1200"
              data-aos-duration="500"
              data-aos-offset="0">
              <JOiningLinks src={dextools} />
            </a>
          </GridImage>
          <GridVideo
            xs={12}
            md={6}
            data-aos="flip-down"
            data-aos-easing="ease-in"
            data-aos-delay="400"
            data-aos-duration="700"
            data-aos-offset="0"
          >
            <VideoBK autoPlay loop muted>
              <source src={arbvideo} type="video/mp4" />
            </VideoBK>
          </GridVideo>
        </GridHEading>
      </Container>
    </SectionMainWrapper>
  );
};

export default Section1_Header;
